import { BadgeCheck, UtensilsCrossed, LayoutGrid, Tag, Truck, Handshake } from "lucide-react";
import { FadeUp, Overline } from "./Reveal";

const FEATURES = [
  {
    icon: BadgeCheck,
    title: "Quality Focus",
    copy: "Carefully selected food products with a strong focus on consistent quality.",
  },
  {
    icon: UtensilsCrossed,
    title: "Authentic Indian Taste",
    copy: "Products representing authentic Indian flavours and food traditions.",
  },
  {
    icon: LayoutGrid,
    title: "Wide Product Portfolio",
    copy: "A diverse range covering spices, snacks, processed foods, pickles, jams and mango products.",
  },
  {
    icon: Tag,
    title: "Private Label Solutions",
    copy: "Products can be packaged under the customer's own brand.",
  },
  {
    icon: Truck,
    title: "Reliable Supply",
    copy: "A streamlined approach from sourcing through packaging and shipment.",
  },
  {
    icon: Handshake,
    title: "Long-Term Partnerships",
    copy: "Focused on building dependable relationships with international buyers.",
  },
];

export default function WhyRbl() {
  return (
    <section id="why-rbl" data-testid="why-section" className="bg-cream py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <FadeUp className="max-w-2xl">
          <Overline>Why RBL EXIM</Overline>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-navy md:text-5xl">
            Built for buyers who value consistency.
          </h2>
        </FadeUp>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <FadeUp key={f.title} delay={i * 0.06}>
              <article
                data-testid={`why-card-${i}`}
                className="group h-full rounded-2xl border border-navy/10 bg-white p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-gold"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
                  <f.icon size={22} strokeWidth={1.8} />
                </span>
                <h3 className="mt-6 font-display text-xl font-semibold tracking-tight text-navy">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-navy/65">{f.copy}</p>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
